import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

export interface DashboardB2BGestaoRequest {
  userId: number;
  dataInicio?: string;
  dataFim?: string;
  vendedor?: string;
  sellerId?: number;
}

export interface DashboardB2BGestaoComparativo {
  descricao: string;
  acessos: number;
  pedidos: number;
  conversao: number;
}

export interface DashboardB2BGestaoDia {
  dia: string;
  acessos: number;
  pedidos: number;
  conversao: number;
}

export interface DashboardB2BGestaoAcesso {
  codigoErp: string;
  nome: string;
  cidade: string;
  estado: string;
  vendedor: string;
  dataAcesso: Date;
}

export interface DashboardB2BGestaoResumo {
  totalAcessos: number;
  totalPedidos: number;
  conversaoGeral: number;
  dias: DashboardB2BGestaoDia[];
  vendedores: DashboardB2BGestaoComparativo[];
  estados: DashboardB2BGestaoComparativo[];
  cidades: DashboardB2BGestaoComparativo[];
  acessos: DashboardB2BGestaoAcesso[];
}

@Injectable({
  providedIn: 'root'
})
export class DashboardB2BGestaoService {
  private baseUrl: string;
  private headers = new HttpHeaders();

  constructor(
    private http: HttpClient,
    @Inject('BASE_URL') baseUrl: string,
    private toastr: ToastrService
  ) {
    this.baseUrl = baseUrl;
  }

  public getResumo(req: DashboardB2BGestaoRequest): Observable<DashboardB2BGestaoResumo> {
    this.headers.set('Content-Type', 'application/json');

    return this.http.post<DashboardB2BGestaoResumo>(this.baseUrl + 'api/DashboardB2BGestao/GetResumo', req, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error('', 'Houve um erro, contate o suporte...');
        return of({
          totalAcessos: 0,
          totalPedidos: 0,
          conversaoGeral: 0,
          dias: [],
          vendedores: [],
          estados: [],
          cidades: [],
          acessos: []
        });
      })
    );
  }
}
